
import { Component, Vue } from "vue-property-decorator";
import { SMQuestionnaire } from "@/store";
import QuestionnaireProgress from "./components/QuestionnaireProgress/QuestionnaireProgress.vue";

@Component({
  components: {
    QuestionnaireProgress,
  },
})
export default class QuestionnaireHeader extends Vue {
  get displayName() {
    return SMQuestionnaire.display_name;
  }

  get progress() {
    if (SMQuestionnaire.progress == null) return 0;
    return SMQuestionnaire.progress;
  }

  get globalErrorMessage() {
    return SMQuestionnaire.globalErrorMessage;
  }
}
